import LoadStylesService from '../../../shared/services/LoadStylesService';

/**
 * Load Redirect Lang Popin dynamically
 */
export default class RedirectLangChunk {
  private readonly body: HTMLElement;

  constructor() {
    const newHeader: HTMLElement = document.querySelector('.l-header');
    this.body = document.querySelector('body');

    /* Load redirect lang's CSS and JS */
    if (
      newHeader &&
      !newHeader.classList.contains('js-popinRedirectLang--cssLoaded')
    ) {
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-redirectLang' */ '../RedirectLang'
      ).then(({ default: RedirectLang }) => {
        if (this.body.id !== 'body') {
          this.addOldCss(newHeader);
        }
        const redirectLang = new RedirectLang();
        redirectLang.execute();
        this.body.classList.add('js-popinRedirectLang--processed');
      });
    }
  }

  /**
   * Load old CSS
   */
  private addOldCss = (newHeader: HTMLElement) => {
    const { cssFilePopinRedirectLang } = newHeader.dataset;
    newHeader.classList.add('js-popinRedirectLang--cssLoaded');
    LoadStylesService.loaderStyle(cssFilePopinRedirectLang);
  };
}
